/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../subscription_service';
import '../../data';
import '../../../common/time';
import '../../../billing/data';
import '../../../common/currency';
import '../../common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sub2": {
        "nested": {
          "service": {
            "nested": {
              "v3": {
                "nested": {
                  "external": {
                    "nested": {
                      "ExternalBatchCreateAndCancelSubscriptionsRequest": {
                        "fields": {
                          "createRequests": {
                            "type": "squareup.sub2.service.BatchCreateAndCancelSubscriptionsRequest.CreateSubscription",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "cancelRequests": {
                            "type": "squareup.sub2.service.BatchCreateAndCancelSubscriptionsRequest.CancelSubscription",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "updateRequests": {
                            "type": "squareup.sub2.service.BatchCreateAndCancelSubscriptionsRequest.UpdateSubscription",
                            "id": 4,
                            "rule": "repeated"
                          },
                          "reason": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalBatchCreateAndCancelSubscriptionsResponse": {
                        "fields": {
                          "created": {
                            "type": "squareup.sub2.service.v3.external.ExternalBatchCreateAndCancelSubscriptionsResponse.CreatedSubscription",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "canceled": {
                            "type": "squareup.sub2.service.v3.external.ExternalBatchCreateAndCancelSubscriptionsResponse.CanceledSubscription",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "updated": {
                            "type": "squareup.sub2.service.v3.external.ExternalBatchCreateAndCancelSubscriptionsResponse.UpdatedSubscription",
                            "id": 3,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "CreatedSubscription": {
                            "fields": {
                              "subscription": {
                                "type": "squareup.sub2.data.Subscription",
                                "id": 1,
                                "rule": "optional"
                              },
                              "succeeded": {
                                "type": "bool",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "CanceledSubscription": {
                            "fields": {
                              "subscription": {
                                "type": "squareup.sub2.data.Subscription",
                                "id": 1,
                                "rule": "optional"
                              },
                              "succeeded": {
                                "type": "bool",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "UpdatedSubscription": {
                            "fields": {
                              "subscription": {
                                "type": "squareup.sub2.data.Subscription",
                                "id": 1,
                                "rule": "optional"
                              },
                              "succeeded": {
                                "type": "bool",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "ExternalCancelSubscriptionRequest": {
                        "fields": {
                          "subscriptionToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "cancelImmediately": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "reason": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "feedback": {
                            "type": "squareup.sub2.data.Feedback",
                            "id": 4,
                            "rule": "repeated"
                          }
                        }
                      },
                      "ExternalCancelSubscriptionResponse": {
                        "fields": {
                          "subscription": {
                            "type": "squareup.sub2.data.Subscription",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalPauseSubscriptionRequest": {
                        "fields": {
                          "subscriptionToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "resumeAt": {
                            "type": "squareup.common.time.DateTime",
                            "id": 2,
                            "rule": "optional"
                          },
                          "resumeAtDate": {
                            "type": "squareup.common.time.YearMonthDay",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalPauseSubscriptionResponse": {
                        "fields": {
                          "subscription": {
                            "type": "squareup.sub2.data.Subscription",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalResumeSubscriptionRequest": {
                        "fields": {
                          "subscriptionToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalResumeSubscriptionResponse": {
                        "fields": {
                          "subscription": {
                            "type": "squareup.sub2.data.Subscription",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalCreateOrUpdateSubscriptionRequest": {
                        "fields": {
                          "subscriptionToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "planToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "reason": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "startInFreeTrialNoObligationState": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "planBillingCycle": {
                            "type": "squareup.billing.data.SubscriptionFeeBillCycle",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalCreateOrUpdateSubscriptionResponse": {
                        "fields": {
                          "subscription": {
                            "type": "squareup.sub2.data.Subscription",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalGetBillerLocationTokenRequest": {
                        "fields": {
                          "countryCode": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalGetBillerLocationTokenResponse": {
                        "fields": {
                          "locationToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "countryCode": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalGetDefaultPricingInfoRequest": {
                        "fields": {
                          "planToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "planBillingCycle": {
                            "type": "squareup.billing.data.SubscriptionFeeBillCycle",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalGetDefaultPricingInfoResponse": {
                        "fields": {
                          "pricing": {
                            "type": "squareup.sub2.data.Pricing",
                            "id": 1,
                            "rule": "optional"
                          },
                          "planName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalGetPlanComponentsRequest": {
                        "fields": {
                          "planToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "planBillingCycle": {
                            "type": "squareup.billing.data.SubscriptionFeeBillCycle",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalGetPlanComponentsResponse": {
                        "fields": {
                          "components": {
                            "type": "squareup.sub2.data.PlanComponent",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      },
                      "ExternalGetPricingInfoRequest": {
                        "fields": {
                          "planToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "subscriptionToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "usageData": {
                            "type": "squareup.sub2.data.Usage",
                            "id": 3,
                            "rule": "optional"
                          },
                          "planBillingCycle": {
                            "type": "squareup.billing.data.SubscriptionFeeBillCycle",
                            "id": 4,
                            "rule": "optional"
                          },
                          "includeEstimatedTax": {
                            "type": "bool",
                            "id": 5,
                            "rule": "optional"
                          },
                          "bundleOfferingToken": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "bundleOfferingVersion": {
                            "type": "uint32",
                            "id": 7,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalGetPricingInfoResponse": {
                        "fields": {
                          "pricing": {
                            "type": "squareup.sub2.data.Pricing",
                            "id": 1,
                            "rule": "optional"
                          },
                          "numFreeTrialDays": {
                            "type": "uint32",
                            "id": 2,
                            "rule": "optional",
                            "options": {
                              "default": 0
                            }
                          },
                          "renewalCycle": {
                            "type": "squareup.sub2.data.Duration",
                            "id": 3,
                            "rule": "optional"
                          },
                          "planName": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "estimatedCost": {
                            "type": "squareup.common.Money",
                            "id": 5,
                            "rule": "optional"
                          },
                          "usageData": {
                            "type": "squareup.sub2.data.Usage",
                            "id": 6,
                            "rule": "optional"
                          },
                          "estimatedTaxCost": {
                            "type": "squareup.common.Money",
                            "id": 7,
                            "rule": "optional"
                          },
                          "estimatedSubtotal": {
                            "type": "squareup.common.Money",
                            "id": 8,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalGetSubscriptionRequest": {
                        "fields": {
                          "subscriptionToken": {
                            "type": "string",
                            "id": 1
                          },
                          "subscriptionKey": {
                            "type": "squareup.sub2.data.SubscriptionKey",
                            "id": 2
                          }
                        },
                        "nested": {
                          "subscription_descriptor": {
                            "oneof": ["subscriptionToken", "subscriptionKey"]
                          }
                        }
                      },
                      "ExternalGetSubscriptionResponse": {
                        "fields": {
                          "subscription": {
                            "type": "squareup.sub2.data.Subscription",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalIsSubscribedToFeatureRequest": {
                        "fields": {
                          "feature": {
                            "type": "squareup.sub2.data.Feature",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalIsSubscribedToFeatureResponse": {
                        "fields": {
                          "isSubscribed": {
                            "type": "bool",
                            "id": 1,
                            "rule": "optional"
                          },
                          "subscriptionStatus": {
                            "type": "squareup.sub2.common.SubscriptionStatus",
                            "id": 2,
                            "rule": "optional"
                          },
                          "subscriptionToken": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalListFeatureStatusesRequest": {
                        "fields": {}
                      },
                      "ExternalListMergedSubscriptionsRequest": {
                        "fields": {}
                      },
                      "ExternalListMergedSubscriptionsResponse": {
                        "fields": {
                          "subscription": {
                            "type": "squareup.sub2.data.Subscription",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "bundles": {
                            "type": "squareup.sub2.data.Bundle",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "ExternalGetPlanGroupRequest": {
                        "fields": {
                          "token": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "subscriber": {
                            "type": "squareup.sub2.data.Entity",
                            "id": 2,
                            "rule": "optional"
                          },
                          "groupBillingCycle": {
                            "type": "squareup.billing.data.SubscriptionFeeBillCycle",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalGetPlanGroupResponse": {
                        "fields": {
                          "planGroup": {
                            "type": "squareup.sub2.data.PlanGroup",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalUpdateSubscriptionRequest": {
                        "fields": {
                          "subscription": {
                            "type": "squareup.sub2.data.Subscription",
                            "id": 1,
                            "rule": "optional"
                          },
                          "startInFreeTrialNoObligationState": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalUpdateSubscriptionResponse": {
                        "fields": {
                          "subscription": {
                            "type": "squareup.sub2.data.Subscription",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalActivatePresaleSubscriptionsRequest": {
                        "fields": {
                          "reason": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalActivatePresaleSubscriptionsResponse": {
                        "fields": {
                          "subscriptions": {
                            "type": "squareup.sub2.data.Subscription",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      },
                      "ExternalCreateBundleRequest": {
                        "fields": {
                          "reason": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "bundleOfferingToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalCreateBundleResponse": {
                        "fields": {
                          "bundle": {
                            "type": "squareup.sub2.data.Bundle",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalCancelBundleRequest": {
                        "fields": {
                          "reason": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "bundleToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalCancelBundleResponse": {
                        "fields": {
                          "bundle": {
                            "type": "squareup.sub2.data.Bundle",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalGetBundleRequest": {
                        "fields": {
                          "bundleToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalGetBundleResponse": {
                        "fields": {
                          "bundle": {
                            "type": "squareup.sub2.data.Bundle",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalListAvailableBundleOfferingsRequest": {
                        "fields": {}
                      },
                      "ExternalListAvailableBundleOfferingsResponse": {
                        "fields": {
                          "bundleOfferings": {
                            "type": "squareup.sub2.data.BundleOffering",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      },
                      "ExternalBulkGetFeatureDiffRequest": {
                        "fields": {
                          "planChanges": {
                            "type": "squareup.sub2.service.BulkGetFeatureDiffRequest.PlanChange",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      },
                      "ExternalBulkGetFeatureDiffResponse": {
                        "fields": {
                          "featureDiffs": {
                            "type": "squareup.sub2.service.v3.external.ExternalBulkGetFeatureDiffResponse.FeatureDiff",
                            "id": 1,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "FeatureDiff": {
                            "fields": {
                              "succeeded": {
                                "type": "bool",
                                "id": 1,
                                "rule": "optional"
                              },
                              "featuresLost": {
                                "type": "squareup.sub2.data.DisplayedFeature",
                                "id": 2,
                                "rule": "repeated"
                              },
                              "featuresMaintained": {
                                "type": "squareup.sub2.data.DisplayedFeature",
                                "id": 3,
                                "rule": "repeated"
                              },
                              "featuresGained": {
                                "type": "squareup.sub2.data.DisplayedFeature",
                                "id": 4,
                                "rule": "repeated"
                              },
                              "errorMessage": {
                                "type": "string",
                                "id": 5,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "ExternalGetFeedbackOptionListForPlanRequest": {
                        "fields": {
                          "planToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalGetFeedbackOptionListForPlanResponse": {
                        "fields": {
                          "feedbackOptionList": {
                            "type": "squareup.sub2.data.FeedbackOptionList",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalGetFutureSubscribedFeatureDiffRequest": {
                        "fields": {
                          "oldPlanTokens": {
                            "type": "string",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "newPlanTokens": {
                            "type": "string",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "ExternalGetFutureSubscribedFeatureDiffResponse": {
                        "fields": {
                          "futureSubscribedFeatures": {
                            "type": "squareup.sub2.data.Feature",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "futureSubscribedFeaturesWithPlanChange": {
                            "type": "squareup.sub2.data.Feature",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "ExternalSyncSquareOneAvtBucketingResultRequest": {
                        "fields": {
                          "merchantToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "avt": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalSyncSquareOneAvtBucketingResultResponse": {
                        "fields": {
                          "avtBucketed": {
                            "type": "bool",
                            "id": 1,
                            "rule": "optional"
                          },
                          "squareOneEligibility": {
                            "type": "squareup.sub2.data.SquareOneEligibility",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalGetOrSetSquareOneEligibilityRequest": {
                        "fields": {
                          "merchantToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalGetOrSetSquareOneEligibilityResponse": {
                        "fields": {
                          "squareOneEligibility": {
                            "type": "squareup.sub2.data.SquareOneEligibility",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "ExternalSubscriptionService": {
                        "methods": {
                          "ExternalBatchCreateAndCancelSubscriptions": {
                            "requestType": "squareup.sub2.service.v3.external.ExternalBatchCreateAndCancelSubscriptionsRequest",
                            "responseType": "squareup.sub2.service.v3.external.ExternalBatchCreateAndCancelSubscriptionsResponse"
                          },
                          "ExternalCancelSubscription": {
                            "requestType": "squareup.sub2.service.v3.external.ExternalCancelSubscriptionRequest",
                            "responseType": "squareup.sub2.service.v3.external.ExternalCancelSubscriptionResponse"
                          },
                          "ExternalPauseSubscription": {
                            "requestType": "squareup.sub2.service.v3.external.ExternalPauseSubscriptionRequest",
                            "responseType": "squareup.sub2.service.v3.external.ExternalPauseSubscriptionResponse"
                          },
                          "ExternalResumeSubscription": {
                            "requestType": "squareup.sub2.service.v3.external.ExternalResumeSubscriptionRequest",
                            "responseType": "squareup.sub2.service.v3.external.ExternalResumeSubscriptionResponse"
                          },
                          "ExternalCreateOrUpdateSubscription": {
                            "requestType": "squareup.sub2.service.v3.external.ExternalCreateOrUpdateSubscriptionRequest",
                            "responseType": "squareup.sub2.service.v3.external.ExternalCreateOrUpdateSubscriptionResponse"
                          },
                          "ExternalGetBillerLocationToken": {
                            "requestType": "squareup.sub2.service.v3.external.ExternalGetBillerLocationTokenRequest",
                            "responseType": "squareup.sub2.service.v3.external.ExternalGetBillerLocationTokenResponse"
                          },
                          "ExternalGetDefaultPricingInfo": {
                            "requestType": "squareup.sub2.service.v3.external.ExternalGetDefaultPricingInfoRequest",
                            "responseType": "squareup.sub2.service.v3.external.ExternalGetDefaultPricingInfoResponse"
                          },
                          "ExternalGetPlanComponents": {
                            "requestType": "squareup.sub2.service.v3.external.ExternalGetPlanComponentsRequest",
                            "responseType": "squareup.sub2.service.v3.external.ExternalGetPlanComponentsResponse"
                          },
                          "ExternalGetPricingInfo": {
                            "requestType": "squareup.sub2.service.v3.external.ExternalGetPricingInfoRequest",
                            "responseType": "squareup.sub2.service.v3.external.ExternalGetPricingInfoResponse"
                          },
                          "ExternalGetSubscription": {
                            "requestType": "squareup.sub2.service.v3.external.ExternalGetSubscriptionRequest",
                            "responseType": "squareup.sub2.service.v3.external.ExternalGetSubscriptionResponse"
                          },
                          "ExternalIsSubscribedToFeature": {
                            "requestType": "squareup.sub2.service.v3.external.ExternalIsSubscribedToFeatureRequest",
                            "responseType": "squareup.sub2.service.v3.external.ExternalIsSubscribedToFeatureResponse"
                          },
                          "ExternalListFeatureStatuses": {
                            "requestType": "squareup.sub2.service.v3.external.ExternalListFeatureStatusesRequest",
                            "responseType": "squareup.sub2.service.ListFeatureStatusesResponse"
                          },
                          "ExternalListMergedSubscriptions": {
                            "requestType": "squareup.sub2.service.v3.external.ExternalListMergedSubscriptionsRequest",
                            "responseType": "squareup.sub2.service.v3.external.ExternalListMergedSubscriptionsResponse"
                          },
                          "ExternalGetPlanGroup": {
                            "requestType": "squareup.sub2.service.v3.external.ExternalGetPlanGroupRequest",
                            "responseType": "squareup.sub2.service.v3.external.ExternalGetPlanGroupResponse"
                          },
                          "ExternalUpdateSubscription": {
                            "requestType": "squareup.sub2.service.v3.external.ExternalUpdateSubscriptionRequest",
                            "responseType": "squareup.sub2.service.v3.external.ExternalUpdateSubscriptionResponse"
                          },
                          "ExternalActivatePresaleSubscriptions": {
                            "requestType": "squareup.sub2.service.v3.external.ExternalActivatePresaleSubscriptionsRequest",
                            "responseType": "squareup.sub2.service.v3.external.ExternalActivatePresaleSubscriptionsResponse"
                          },
                          "ExternalCreateBundle": {
                            "requestType": "squareup.sub2.service.v3.external.ExternalCreateBundleRequest",
                            "responseType": "squareup.sub2.service.v3.external.ExternalCreateBundleResponse"
                          },
                          "ExternalCancelBundle": {
                            "requestType": "squareup.sub2.service.v3.external.ExternalCancelBundleRequest",
                            "responseType": "squareup.sub2.service.v3.external.ExternalCancelBundleResponse"
                          },
                          "ExternalGetBundle": {
                            "requestType": "squareup.sub2.service.v3.external.ExternalGetBundleRequest",
                            "responseType": "squareup.sub2.service.v3.external.ExternalGetBundleResponse"
                          },
                          "ExternalListAvailableBundleOfferings": {
                            "requestType": "squareup.sub2.service.v3.external.ExternalListAvailableBundleOfferingsRequest",
                            "responseType": "squareup.sub2.service.v3.external.ExternalListAvailableBundleOfferingsResponse"
                          },
                          "ExternalBulkGetFeatureDiff": {
                            "requestType": "squareup.sub2.service.v3.external.ExternalBulkGetFeatureDiffRequest",
                            "responseType": "squareup.sub2.service.v3.external.ExternalBulkGetFeatureDiffResponse"
                          },
                          "ExternalGetFeedbackOptionListForPlan": {
                            "requestType": "squareup.sub2.service.v3.external.ExternalGetFeedbackOptionListForPlanRequest",
                            "responseType": "squareup.sub2.service.v3.external.ExternalGetFeedbackOptionListForPlanResponse"
                          },
                          "ExternalGetFutureSubscribedFeatureDiff": {
                            "requestType": "squareup.sub2.service.v3.external.ExternalGetFutureSubscribedFeatureDiffRequest",
                            "responseType": "squareup.sub2.service.v3.external.ExternalGetFutureSubscribedFeatureDiffResponse"
                          },
                          "ExternalSyncSquareOneAvtBucketingResult": {
                            "requestType": "squareup.sub2.service.v3.external.ExternalSyncSquareOneAvtBucketingResultRequest",
                            "responseType": "squareup.sub2.service.v3.external.ExternalSyncSquareOneAvtBucketingResultResponse"
                          },
                          "ExternalGetOrSetSquareOneEligibility": {
                            "requestType": "squareup.sub2.service.v3.external.ExternalGetOrSetSquareOneEligibilityRequest",
                            "responseType": "squareup.sub2.service.v3.external.ExternalGetOrSetSquareOneEligibilityResponse"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalBatchCreateAndCancelSubscriptionsRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalBatchCreateAndCancelSubscriptionsResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalBatchCreateAndCancelSubscriptionsResponse?.nested?.CreatedSubscription && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalBatchCreateAndCancelSubscriptionsResponse?.nested?.CanceledSubscription && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalBatchCreateAndCancelSubscriptionsResponse?.nested?.UpdatedSubscription && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalCancelSubscriptionRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalCancelSubscriptionResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalPauseSubscriptionRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalPauseSubscriptionResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalResumeSubscriptionRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalResumeSubscriptionResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalCreateOrUpdateSubscriptionRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalCreateOrUpdateSubscriptionResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalGetBillerLocationTokenRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalGetBillerLocationTokenResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalGetDefaultPricingInfoRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalGetDefaultPricingInfoResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalGetPlanComponentsRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalGetPlanComponentsResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalGetPricingInfoRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalGetPricingInfoResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalGetSubscriptionRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalGetSubscriptionResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalIsSubscribedToFeatureRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalIsSubscribedToFeatureResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalListFeatureStatusesRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalListMergedSubscriptionsRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalListMergedSubscriptionsResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalGetPlanGroupRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalGetPlanGroupResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalUpdateSubscriptionRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalUpdateSubscriptionResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalActivatePresaleSubscriptionsRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalActivatePresaleSubscriptionsResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalCreateBundleRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalCreateBundleResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalCancelBundleRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalCancelBundleResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalGetBundleRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalGetBundleResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalListAvailableBundleOfferingsRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalListAvailableBundleOfferingsResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalBulkGetFeatureDiffRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalBulkGetFeatureDiffResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalBulkGetFeatureDiffResponse?.nested?.FeatureDiff && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalGetFeedbackOptionListForPlanRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalGetFeedbackOptionListForPlanResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalGetFutureSubscribedFeatureDiffRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalGetFutureSubscribedFeatureDiffResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalSyncSquareOneAvtBucketingResultRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalSyncSquareOneAvtBucketingResultResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalGetOrSetSquareOneEligibilityRequest && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalGetOrSetSquareOneEligibilityResponse && !$root.nested?.squareup?.nested?.sub2?.nested?.service?.nested?.v3?.nested?.external?.nested?.ExternalSubscriptionService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ExternalBatchCreateAndCancelSubscriptionsRequest @ squareup/sub2/v3/external/external_subscription_service.proto at 18:1
 */
export const ExternalBatchCreateAndCancelSubscriptionsRequest = $root.lookupType('squareup.sub2.service.v3.external.ExternalBatchCreateAndCancelSubscriptionsRequest');
fixType(ExternalBatchCreateAndCancelSubscriptionsRequest);
Builder.createAndAttachToType(ExternalBatchCreateAndCancelSubscriptionsRequest);
/**
 * SOURCE ExternalBatchCreateAndCancelSubscriptionsResponse @ squareup/sub2/v3/external/external_subscription_service.proto at 32:1
 */
export const ExternalBatchCreateAndCancelSubscriptionsResponse = $root.lookupType('squareup.sub2.service.v3.external.ExternalBatchCreateAndCancelSubscriptionsResponse');
fixType(ExternalBatchCreateAndCancelSubscriptionsResponse);
Builder.createAndAttachToType(ExternalBatchCreateAndCancelSubscriptionsResponse);
/**
 * SOURCE CreatedSubscription @ squareup/sub2/v3/external/external_subscription_service.proto at 33:3
 */
ExternalBatchCreateAndCancelSubscriptionsResponse.CreatedSubscription = $root.lookupType('squareup.sub2.service.v3.external.ExternalBatchCreateAndCancelSubscriptionsResponse.CreatedSubscription');
fixType(ExternalBatchCreateAndCancelSubscriptionsResponse.CreatedSubscription, {
  subscription: {
    required: true
  },
  succeeded: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalBatchCreateAndCancelSubscriptionsResponse.CreatedSubscription);
/**
 * SOURCE CanceledSubscription @ squareup/sub2/v3/external/external_subscription_service.proto at 41:3
 */
ExternalBatchCreateAndCancelSubscriptionsResponse.CanceledSubscription = $root.lookupType('squareup.sub2.service.v3.external.ExternalBatchCreateAndCancelSubscriptionsResponse.CanceledSubscription');
fixType(ExternalBatchCreateAndCancelSubscriptionsResponse.CanceledSubscription, {
  subscription: {
    required: true
  },
  succeeded: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalBatchCreateAndCancelSubscriptionsResponse.CanceledSubscription);
/**
 * SOURCE UpdatedSubscription @ squareup/sub2/v3/external/external_subscription_service.proto at 49:3
 */
ExternalBatchCreateAndCancelSubscriptionsResponse.UpdatedSubscription = $root.lookupType('squareup.sub2.service.v3.external.ExternalBatchCreateAndCancelSubscriptionsResponse.UpdatedSubscription');
fixType(ExternalBatchCreateAndCancelSubscriptionsResponse.UpdatedSubscription, {
  subscription: {
    required: true
  },
  succeeded: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalBatchCreateAndCancelSubscriptionsResponse.UpdatedSubscription);
/**
 * SOURCE ExternalCancelSubscriptionRequest @ squareup/sub2/v3/external/external_subscription_service.proto at 67:1
 */
export const ExternalCancelSubscriptionRequest = $root.lookupType('squareup.sub2.service.v3.external.ExternalCancelSubscriptionRequest');
fixType(ExternalCancelSubscriptionRequest, {
  subscriptionToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ExternalCancelSubscriptionRequest);
/**
 * SOURCE ExternalCancelSubscriptionResponse @ squareup/sub2/v3/external/external_subscription_service.proto at 84:1
 */
export const ExternalCancelSubscriptionResponse = $root.lookupType('squareup.sub2.service.v3.external.ExternalCancelSubscriptionResponse');
fixType(ExternalCancelSubscriptionResponse);
Builder.createAndAttachToType(ExternalCancelSubscriptionResponse);
/**
 * SOURCE ExternalPauseSubscriptionRequest @ squareup/sub2/v3/external/external_subscription_service.proto at 89:1
 */
export const ExternalPauseSubscriptionRequest = $root.lookupType('squareup.sub2.service.v3.external.ExternalPauseSubscriptionRequest');
fixType(ExternalPauseSubscriptionRequest, {
  subscriptionToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ExternalPauseSubscriptionRequest);
/**
 * SOURCE ExternalPauseSubscriptionResponse @ squareup/sub2/v3/external/external_subscription_service.proto at 97:1
 */
export const ExternalPauseSubscriptionResponse = $root.lookupType('squareup.sub2.service.v3.external.ExternalPauseSubscriptionResponse');
fixType(ExternalPauseSubscriptionResponse);
Builder.createAndAttachToType(ExternalPauseSubscriptionResponse);
/**
 * SOURCE ExternalResumeSubscriptionRequest @ squareup/sub2/v3/external/external_subscription_service.proto at 102:1
 */
export const ExternalResumeSubscriptionRequest = $root.lookupType('squareup.sub2.service.v3.external.ExternalResumeSubscriptionRequest');
fixType(ExternalResumeSubscriptionRequest, {
  subscriptionToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ExternalResumeSubscriptionRequest);
/**
 * SOURCE ExternalResumeSubscriptionResponse @ squareup/sub2/v3/external/external_subscription_service.proto at 107:1
 */
export const ExternalResumeSubscriptionResponse = $root.lookupType('squareup.sub2.service.v3.external.ExternalResumeSubscriptionResponse');
fixType(ExternalResumeSubscriptionResponse);
Builder.createAndAttachToType(ExternalResumeSubscriptionResponse);
/**
 * SOURCE ExternalCreateOrUpdateSubscriptionRequest @ squareup/sub2/v3/external/external_subscription_service.proto at 112:1
 */
export const ExternalCreateOrUpdateSubscriptionRequest = $root.lookupType('squareup.sub2.service.v3.external.ExternalCreateOrUpdateSubscriptionRequest');
fixType(ExternalCreateOrUpdateSubscriptionRequest);
Builder.createAndAttachToType(ExternalCreateOrUpdateSubscriptionRequest);
/**
 * SOURCE ExternalCreateOrUpdateSubscriptionResponse @ squareup/sub2/v3/external/external_subscription_service.proto at 142:1
 */
export const ExternalCreateOrUpdateSubscriptionResponse = $root.lookupType('squareup.sub2.service.v3.external.ExternalCreateOrUpdateSubscriptionResponse');
fixType(ExternalCreateOrUpdateSubscriptionResponse);
Builder.createAndAttachToType(ExternalCreateOrUpdateSubscriptionResponse);
/**
 * SOURCE ExternalGetBillerLocationTokenRequest @ squareup/sub2/v3/external/external_subscription_service.proto at 147:1
 */
export const ExternalGetBillerLocationTokenRequest = $root.lookupType('squareup.sub2.service.v3.external.ExternalGetBillerLocationTokenRequest');
fixType(ExternalGetBillerLocationTokenRequest, {
  countryCode: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalGetBillerLocationTokenRequest);
/**
 * SOURCE ExternalGetBillerLocationTokenResponse @ squareup/sub2/v3/external/external_subscription_service.proto at 152:1
 */
export const ExternalGetBillerLocationTokenResponse = $root.lookupType('squareup.sub2.service.v3.external.ExternalGetBillerLocationTokenResponse');
fixType(ExternalGetBillerLocationTokenResponse, {
  locationToken: {
    required: true
  },
  countryCode: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalGetBillerLocationTokenResponse);
/**
 * SOURCE ExternalGetDefaultPricingInfoRequest @ squareup/sub2/v3/external/external_subscription_service.proto at 163:1
 */
export const ExternalGetDefaultPricingInfoRequest = $root.lookupType('squareup.sub2.service.v3.external.ExternalGetDefaultPricingInfoRequest');
fixType(ExternalGetDefaultPricingInfoRequest);
Builder.createAndAttachToType(ExternalGetDefaultPricingInfoRequest);
/**
 * SOURCE ExternalGetDefaultPricingInfoResponse @ squareup/sub2/v3/external/external_subscription_service.proto at 174:1
 */
export const ExternalGetDefaultPricingInfoResponse = $root.lookupType('squareup.sub2.service.v3.external.ExternalGetDefaultPricingInfoResponse');
fixType(ExternalGetDefaultPricingInfoResponse, {
  pricing: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalGetDefaultPricingInfoResponse);
/**
 * SOURCE ExternalGetPlanComponentsRequest @ squareup/sub2/v3/external/external_subscription_service.proto at 182:1
 */
export const ExternalGetPlanComponentsRequest = $root.lookupType('squareup.sub2.service.v3.external.ExternalGetPlanComponentsRequest');
fixType(ExternalGetPlanComponentsRequest);
Builder.createAndAttachToType(ExternalGetPlanComponentsRequest);
/**
 * SOURCE ExternalGetPlanComponentsResponse @ squareup/sub2/v3/external/external_subscription_service.proto at 193:1
 */
export const ExternalGetPlanComponentsResponse = $root.lookupType('squareup.sub2.service.v3.external.ExternalGetPlanComponentsResponse');
fixType(ExternalGetPlanComponentsResponse);
Builder.createAndAttachToType(ExternalGetPlanComponentsResponse);
/**
 * SOURCE ExternalGetPricingInfoRequest @ squareup/sub2/v3/external/external_subscription_service.proto at 198:1
 */
export const ExternalGetPricingInfoRequest = $root.lookupType('squareup.sub2.service.v3.external.ExternalGetPricingInfoRequest');
fixType(ExternalGetPricingInfoRequest);
Builder.createAndAttachToType(ExternalGetPricingInfoRequest);
/**
 * SOURCE ExternalGetPricingInfoResponse @ squareup/sub2/v3/external/external_subscription_service.proto at 238:1
 */
export const ExternalGetPricingInfoResponse = $root.lookupType('squareup.sub2.service.v3.external.ExternalGetPricingInfoResponse');
fixType(ExternalGetPricingInfoResponse, {
  pricing: {
    required: true
  },
  renewalCycle: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalGetPricingInfoResponse);
/**
 * SOURCE ExternalGetSubscriptionRequest @ squareup/sub2/v3/external/external_subscription_service.proto at 267:1
 */
export const ExternalGetSubscriptionRequest = $root.lookupType('squareup.sub2.service.v3.external.ExternalGetSubscriptionRequest');
fixType(ExternalGetSubscriptionRequest);
Builder.createAndAttachToType(ExternalGetSubscriptionRequest);
/**
 * SOURCE ExternalGetSubscriptionResponse @ squareup/sub2/v3/external/external_subscription_service.proto at 277:1
 */
export const ExternalGetSubscriptionResponse = $root.lookupType('squareup.sub2.service.v3.external.ExternalGetSubscriptionResponse');
fixType(ExternalGetSubscriptionResponse);
Builder.createAndAttachToType(ExternalGetSubscriptionResponse);
/**
 * SOURCE ExternalIsSubscribedToFeatureRequest @ squareup/sub2/v3/external/external_subscription_service.proto at 282:1
 */
export const ExternalIsSubscribedToFeatureRequest = $root.lookupType('squareup.sub2.service.v3.external.ExternalIsSubscribedToFeatureRequest');
fixType(ExternalIsSubscribedToFeatureRequest, {
  feature: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalIsSubscribedToFeatureRequest);
/**
 * SOURCE ExternalIsSubscribedToFeatureResponse @ squareup/sub2/v3/external/external_subscription_service.proto at 290:1
 */
export const ExternalIsSubscribedToFeatureResponse = $root.lookupType('squareup.sub2.service.v3.external.ExternalIsSubscribedToFeatureResponse');
fixType(ExternalIsSubscribedToFeatureResponse, {
  isSubscribed: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalIsSubscribedToFeatureResponse);
/**
 * SOURCE ExternalListFeatureStatusesRequest @ squareup/sub2/v3/external/external_subscription_service.proto at 301:1
 */
export const ExternalListFeatureStatusesRequest = $root.lookupType('squareup.sub2.service.v3.external.ExternalListFeatureStatusesRequest');
fixType(ExternalListFeatureStatusesRequest);
Builder.createAndAttachToType(ExternalListFeatureStatusesRequest);
/**
 * SOURCE ExternalListMergedSubscriptionsRequest @ squareup/sub2/v3/external/external_subscription_service.proto at 304:1
 */
export const ExternalListMergedSubscriptionsRequest = $root.lookupType('squareup.sub2.service.v3.external.ExternalListMergedSubscriptionsRequest');
fixType(ExternalListMergedSubscriptionsRequest);
Builder.createAndAttachToType(ExternalListMergedSubscriptionsRequest);
/**
 * SOURCE ExternalListMergedSubscriptionsResponse @ squareup/sub2/v3/external/external_subscription_service.proto at 307:1
 */
export const ExternalListMergedSubscriptionsResponse = $root.lookupType('squareup.sub2.service.v3.external.ExternalListMergedSubscriptionsResponse');
fixType(ExternalListMergedSubscriptionsResponse);
Builder.createAndAttachToType(ExternalListMergedSubscriptionsResponse);
/**
 * SOURCE ExternalGetPlanGroupRequest @ squareup/sub2/v3/external/external_subscription_service.proto at 315:1
 */
export const ExternalGetPlanGroupRequest = $root.lookupType('squareup.sub2.service.v3.external.ExternalGetPlanGroupRequest');
fixType(ExternalGetPlanGroupRequest, {
  token: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalGetPlanGroupRequest);
/**
 * SOURCE ExternalGetPlanGroupResponse @ squareup/sub2/v3/external/external_subscription_service.proto at 330:1
 */
export const ExternalGetPlanGroupResponse = $root.lookupType('squareup.sub2.service.v3.external.ExternalGetPlanGroupResponse');
fixType(ExternalGetPlanGroupResponse);
Builder.createAndAttachToType(ExternalGetPlanGroupResponse);
/**
 * SOURCE ExternalUpdateSubscriptionRequest @ squareup/sub2/v3/external/external_subscription_service.proto at 334:1
 */
export const ExternalUpdateSubscriptionRequest = $root.lookupType('squareup.sub2.service.v3.external.ExternalUpdateSubscriptionRequest');
fixType(ExternalUpdateSubscriptionRequest, {
  subscription: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalUpdateSubscriptionRequest);
/**
 * SOURCE ExternalUpdateSubscriptionResponse @ squareup/sub2/v3/external/external_subscription_service.proto at 346:1
 */
export const ExternalUpdateSubscriptionResponse = $root.lookupType('squareup.sub2.service.v3.external.ExternalUpdateSubscriptionResponse');
fixType(ExternalUpdateSubscriptionResponse);
Builder.createAndAttachToType(ExternalUpdateSubscriptionResponse);
/**
 * SOURCE ExternalActivatePresaleSubscriptionsRequest @ squareup/sub2/v3/external/external_subscription_service.proto at 351:1
 */
export const ExternalActivatePresaleSubscriptionsRequest = $root.lookupType('squareup.sub2.service.v3.external.ExternalActivatePresaleSubscriptionsRequest');
fixType(ExternalActivatePresaleSubscriptionsRequest);
Builder.createAndAttachToType(ExternalActivatePresaleSubscriptionsRequest);
/**
 * SOURCE ExternalActivatePresaleSubscriptionsResponse @ squareup/sub2/v3/external/external_subscription_service.proto at 356:1
 */
export const ExternalActivatePresaleSubscriptionsResponse = $root.lookupType('squareup.sub2.service.v3.external.ExternalActivatePresaleSubscriptionsResponse');
fixType(ExternalActivatePresaleSubscriptionsResponse);
Builder.createAndAttachToType(ExternalActivatePresaleSubscriptionsResponse);
/**
 * Returns the bundle created for the seller.
 *
 * SOURCE ExternalCreateBundleRequest @ squareup/sub2/v3/external/external_subscription_service.proto at 364:1
 */
export const ExternalCreateBundleRequest = $root.lookupType('squareup.sub2.service.v3.external.ExternalCreateBundleRequest');
fixType(ExternalCreateBundleRequest, {
  bundleOfferingToken: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalCreateBundleRequest);
/**
 * SOURCE ExternalCreateBundleResponse @ squareup/sub2/v3/external/external_subscription_service.proto at 373:1
 */
export const ExternalCreateBundleResponse = $root.lookupType('squareup.sub2.service.v3.external.ExternalCreateBundleResponse');
fixType(ExternalCreateBundleResponse, {
  bundle: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalCreateBundleResponse);
/**
 * Returns the bundle canceled for the seller.
 *
 * SOURCE ExternalCancelBundleRequest @ squareup/sub2/v3/external/external_subscription_service.proto at 381:1
 */
export const ExternalCancelBundleRequest = $root.lookupType('squareup.sub2.service.v3.external.ExternalCancelBundleRequest');
fixType(ExternalCancelBundleRequest, {
  bundleToken: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalCancelBundleRequest);
/**
 * SOURCE ExternalCancelBundleResponse @ squareup/sub2/v3/external/external_subscription_service.proto at 390:1
 */
export const ExternalCancelBundleResponse = $root.lookupType('squareup.sub2.service.v3.external.ExternalCancelBundleResponse');
fixType(ExternalCancelBundleResponse, {
  bundle: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalCancelBundleResponse);
/**
 * Returns the bundle associated with this token
 *
 * SOURCE ExternalGetBundleRequest @ squareup/sub2/v3/external/external_subscription_service.proto at 398:1
 */
export const ExternalGetBundleRequest = $root.lookupType('squareup.sub2.service.v3.external.ExternalGetBundleRequest');
fixType(ExternalGetBundleRequest);
Builder.createAndAttachToType(ExternalGetBundleRequest);
/**
 * SOURCE ExternalGetBundleResponse @ squareup/sub2/v3/external/external_subscription_service.proto at 402:1
 */
export const ExternalGetBundleResponse = $root.lookupType('squareup.sub2.service.v3.external.ExternalGetBundleResponse');
fixType(ExternalGetBundleResponse);
Builder.createAndAttachToType(ExternalGetBundleResponse);
/**
 * Returns the bundle offerings available to the seller.
 *
 * SOURCE ExternalListAvailableBundleOfferingsRequest @ squareup/sub2/v3/external/external_subscription_service.proto at 410:1
 */
export const ExternalListAvailableBundleOfferingsRequest = $root.lookupType('squareup.sub2.service.v3.external.ExternalListAvailableBundleOfferingsRequest');
fixType(ExternalListAvailableBundleOfferingsRequest);
Builder.createAndAttachToType(ExternalListAvailableBundleOfferingsRequest);
/**
 * SOURCE ExternalListAvailableBundleOfferingsResponse @ squareup/sub2/v3/external/external_subscription_service.proto at 413:1
 */
export const ExternalListAvailableBundleOfferingsResponse = $root.lookupType('squareup.sub2.service.v3.external.ExternalListAvailableBundleOfferingsResponse');
fixType(ExternalListAvailableBundleOfferingsResponse);
Builder.createAndAttachToType(ExternalListAvailableBundleOfferingsResponse);
/**
 * This endpoint will be called in Dashboard to show a list of features lost, maintained, or gained by a plan change,
 * as defined by the set of features on a plan but also taking into account the features that the subscriber has through
 *  other plans.This endpoint supports bulk requests but does not diff across PlanChanges
 * - The response from this endpoint does not correspond directly to sub2.data.Features but can be considered more as
 *   lists of seller-facing feature "descriptions" as determined by Content teams
 *
 * SOURCE ExternalBulkGetFeatureDiffRequest @ squareup/sub2/v3/external/external_subscription_service.proto at 424:1
 */
export const ExternalBulkGetFeatureDiffRequest = $root.lookupType('squareup.sub2.service.v3.external.ExternalBulkGetFeatureDiffRequest');
fixType(ExternalBulkGetFeatureDiffRequest);
Builder.createAndAttachToType(ExternalBulkGetFeatureDiffRequest);
/**
 * SOURCE ExternalBulkGetFeatureDiffResponse @ squareup/sub2/v3/external/external_subscription_service.proto at 428:1
 */
export const ExternalBulkGetFeatureDiffResponse = $root.lookupType('squareup.sub2.service.v3.external.ExternalBulkGetFeatureDiffResponse');
fixType(ExternalBulkGetFeatureDiffResponse);
Builder.createAndAttachToType(ExternalBulkGetFeatureDiffResponse);
/**
 * SOURCE FeatureDiff @ squareup/sub2/v3/external/external_subscription_service.proto at 429:3
 */
ExternalBulkGetFeatureDiffResponse.FeatureDiff = $root.lookupType('squareup.sub2.service.v3.external.ExternalBulkGetFeatureDiffResponse.FeatureDiff');
fixType(ExternalBulkGetFeatureDiffResponse.FeatureDiff, {
  succeeded: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalBulkGetFeatureDiffResponse.FeatureDiff);
/**
 * SOURCE ExternalGetFeedbackOptionListForPlanRequest @ squareup/sub2/v3/external/external_subscription_service.proto at 448:1
 */
export const ExternalGetFeedbackOptionListForPlanRequest = $root.lookupType('squareup.sub2.service.v3.external.ExternalGetFeedbackOptionListForPlanRequest');
fixType(ExternalGetFeedbackOptionListForPlanRequest);
Builder.createAndAttachToType(ExternalGetFeedbackOptionListForPlanRequest);
/**
 * SOURCE ExternalGetFeedbackOptionListForPlanResponse @ squareup/sub2/v3/external/external_subscription_service.proto at 453:1
 */
export const ExternalGetFeedbackOptionListForPlanResponse = $root.lookupType('squareup.sub2.service.v3.external.ExternalGetFeedbackOptionListForPlanResponse');
fixType(ExternalGetFeedbackOptionListForPlanResponse);
Builder.createAndAttachToType(ExternalGetFeedbackOptionListForPlanResponse);
/**
 * SOURCE ExternalGetFutureSubscribedFeatureDiffRequest @ squareup/sub2/v3/external/external_subscription_service.proto at 458:1
 */
export const ExternalGetFutureSubscribedFeatureDiffRequest = $root.lookupType('squareup.sub2.service.v3.external.ExternalGetFutureSubscribedFeatureDiffRequest');
fixType(ExternalGetFutureSubscribedFeatureDiffRequest);
Builder.createAndAttachToType(ExternalGetFutureSubscribedFeatureDiffRequest);
/**
 * SOURCE ExternalGetFutureSubscribedFeatureDiffResponse @ squareup/sub2/v3/external/external_subscription_service.proto at 466:1
 */
export const ExternalGetFutureSubscribedFeatureDiffResponse = $root.lookupType('squareup.sub2.service.v3.external.ExternalGetFutureSubscribedFeatureDiffResponse');
fixType(ExternalGetFutureSubscribedFeatureDiffResponse);
Builder.createAndAttachToType(ExternalGetFutureSubscribedFeatureDiffResponse);
/**
 * SOURCE ExternalSyncSquareOneAvtBucketingResultRequest @ squareup/sub2/v3/external/external_subscription_service.proto at 475:1
 */
export const ExternalSyncSquareOneAvtBucketingResultRequest = $root.lookupType('squareup.sub2.service.v3.external.ExternalSyncSquareOneAvtBucketingResultRequest');
fixType(ExternalSyncSquareOneAvtBucketingResultRequest, {
  merchantToken: {
    required: true
  },
  avt: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalSyncSquareOneAvtBucketingResultRequest);
/**
 * SOURCE ExternalSyncSquareOneAvtBucketingResultResponse @ squareup/sub2/v3/external/external_subscription_service.proto at 486:1
 */
export const ExternalSyncSquareOneAvtBucketingResultResponse = $root.lookupType('squareup.sub2.service.v3.external.ExternalSyncSquareOneAvtBucketingResultResponse');
fixType(ExternalSyncSquareOneAvtBucketingResultResponse);
Builder.createAndAttachToType(ExternalSyncSquareOneAvtBucketingResultResponse);
/**
 * SOURCE ExternalGetOrSetSquareOneEligibilityRequest @ squareup/sub2/v3/external/external_subscription_service.proto at 494:1
 */
export const ExternalGetOrSetSquareOneEligibilityRequest = $root.lookupType('squareup.sub2.service.v3.external.ExternalGetOrSetSquareOneEligibilityRequest');
fixType(ExternalGetOrSetSquareOneEligibilityRequest, {
  merchantToken: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalGetOrSetSquareOneEligibilityRequest);
/**
 * SOURCE ExternalGetOrSetSquareOneEligibilityResponse @ squareup/sub2/v3/external/external_subscription_service.proto at 499:1
 */
export const ExternalGetOrSetSquareOneEligibilityResponse = $root.lookupType('squareup.sub2.service.v3.external.ExternalGetOrSetSquareOneEligibilityResponse');
fixType(ExternalGetOrSetSquareOneEligibilityResponse);
Builder.createAndAttachToType(ExternalGetOrSetSquareOneEligibilityResponse);
/**
 * ExternalSubscriptionService provides APIs to manage subscriptions for products.
 *
 * SOURCE ExternalSubscriptionService @ squareup/sub2/v3/external/external_subscription_service.proto at 507:1
 */
export const ExternalSubscriptionService = $root.lookupService('squareup.sub2.service.v3.external.ExternalSubscriptionService');